export default __webpack_public_path__ + "static/media/star animation.355fb2ab.gif";